import {
  SEARCH_FACTURAS,
  FETCH_FACTURAS,
  FETCH_PENDIENTE,
  FETCH_PRESENTADA,
  FETCH_EN_LIQUIDACION,
  LOADING_FACTURAS_END,
  LOADING_FACTURAS,
  RESET_FACTURAS,
  SHOW_FILTERS,
  HIDE_FILTERS,
} from '../constants/index';

function filterFacturas(state, data) {
  return { ...state, ultimasFacturas: data, ultimasFacturasInit: data };
}
function filterPendientes(state, data) {
  return { ...state, pendienteLiquidacion: data };
}
function filterEnLiquidación(state, data) {
  return { ...state, enLiquidacion: data };
}
function filterPresentadas(state, data) {
  return { ...state, presentadas: data };
}
function filterSearchFacturas(state, data) {
  return { ...state, ultimasFacturas: data };
}
function resetFacturas(state) {
  return { ...state, ultimasFacturas: state.ultimasFacturasInit };
}

const initialState = {
  ultimasFacturas: null,
  ultimasFacturasInit: [],
  pendienteLiquidacion: [],
  enLiquidacion: [],
  presentadas: [],
};

export default function facturas(state = initialState, action) {
  const newState = { ...state };
  switch (action.type) {
    case SEARCH_FACTURAS:
      return filterSearchFacturas(state, action.facturas);
    case FETCH_FACTURAS:
      return filterFacturas(state, action.facturas);
    case RESET_FACTURAS:
      return resetFacturas(state);
    case FETCH_PENDIENTE:
      return filterPendientes(state, action.facturas);
    case FETCH_PRESENTADA:
      return filterPresentadas(state, action.facturas);
    case FETCH_EN_LIQUIDACION:
      return filterEnLiquidación(state, action.facturas);
    case LOADING_FACTURAS_END:
      newState.loading = false;
      return newState;
    case LOADING_FACTURAS:
      newState.loading = true;
      return newState;
    case SHOW_FILTERS:
      newState.showFilters = true;
      return newState;
    case HIDE_FILTERS:
      newState.showFilters = false;
      return newState;
    default:
      return state;
  }
}
